// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.area_Yd4D8 {
  background-color: #080613;
}
.pane_HEZFD {
  padding : 40px 0px 0px !important;
  width: 464px;
}

.pane_HEZFD > div {
  width: 100%
}

.pane_HEZFD > div > form {
  width: 100%;
  padding : 40px !important;
}

.logo_DIkWX {
  width : 216px;
  margin-bottom : 20px;
}

.header_mUF3D {
  padding : 8px 0 0 0 !important;
}
.user_ocdyc {
  width : 250px;
}

.password_ejnOs {
  width : 250px;
}

.login_gBjbr {
  margin-top : 20px !important; 
  align-self : center;
  width: 100% !important;
}

.hideLogin_CwlC1 {
  display : none !important;
}

.warning_lW1zi {
  text-align:left;
}

.logoContainer_KxnTm {
  border-bottom: 1px solid #E7EAEF;
  width : 100%;
}


`, "",{"version":3,"sources":["webpack://./src/screens/login/style.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd","sourcesContent":["\n.area {\n  background-color: #080613;\n}\n.pane {\n  padding : 40px 0px 0px !important;\n  width: 464px;\n}\n\n.pane > div {\n  width: 100%\n}\n\n.pane > div > form {\n  width: 100%;\n  padding : 40px !important;\n}\n\n.logo {\n  width : 216px;\n  margin-bottom : 20px;\n}\n\n.header {\n  padding : 8px 0 0 0 !important;\n}\n.user {\n  width : 250px;\n}\n\n.password {\n  width : 250px;\n}\n\n.login {\n  margin-top : 20px !important; \n  align-self : center;\n  width: 100% !important;\n}\n\n.hideLogin {\n  display : none !important;\n}\n\n.warning {\n  text-align:left;\n}\n\n.logoContainer {\n  border-bottom: 1px solid #E7EAEF;\n  width : 100%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"area": `area_Yd4D8`,
	"pane": `pane_HEZFD`,
	"logo": `logo_DIkWX`,
	"header": `header_mUF3D`,
	"user": `user_ocdyc`,
	"password": `password_ejnOs`,
	"login": `login_gBjbr`,
	"hideLogin": `hideLogin_CwlC1`,
	"warning": `warning_lW1zi`,
	"logoContainer": `logoContainer_KxnTm`
};
export default ___CSS_LOADER_EXPORT___;
